<template>
    <el-table :data="companies" @row-click="companySelected" row-class-name="cpointer">
        <el-table-column prop="name" :label="$t.__('common.labels.society_name')">
            <template slot-scope="scope">
                <p>
                    {{ scope.row.name }}
                    <span v-if="scope.row.companySign"> ({{ scope.row.companySign }}) </span>
                </p>
            </template>
        </el-table-column>
        <el-table-column prop="companyType" :label="$t.__('common.labels.type')"> </el-table-column>
        <el-table-column prop="companyId" :label="$t.__('common.labels.siren')"> </el-table-column>
        <el-table-column prop="siret" :label="$t.__('common.labels.siret')"> </el-table-column>
        <el-table-column prop="companyJobCode" :label="$t.__('common.labels.NAF_code')">
        </el-table-column>
        <el-table-column prop="address" :label="$t.__('common.labels.address')"> </el-table-column>
    </el-table>
</template>
<script>
export default {
    props: {
        companies: {
            required: true,
            type: Array,
        },
        countryCode: {
            required: true,
            type: String,
        },
    },
    methods: {
        companySelected(row) {
            this.$emit('companySelected', {
                companyId: row.companyId,
                queryParams: { countryCode: this.countryCode, siret: row.siret },
            });
        },
    },
};
</script>
